import { InfoType } from "@/models/common/enums";
import shoppingSvg from "@/utils/svg-icon/shopping";
import { MDBBtn } from "mdb-react-ui-kit";
import React, { useState } from "react";
import stylesAddToCart from "@/styles/detail/DetailAddToCart.module.scss";
import styles from "@/styles/detail/DetailBookingSidebar/PackageConfigurationSectionDetail.module.scss";
import { useStore } from "@/store/index";
import TagManager from "react-gtm-module";
import { useRouter } from "next/router";
import { getPackageDetailByTitle } from "@/utils/queries";
import { useQuery } from "@tanstack/react-query";
import adapterTourViewItemGAnalytics from "@/models/tour";
import { addToCart } from "@/utils/analytics/tagmanager";

const ButtonBuySectionDetail = ({
    errorGuest,
    toggleInfoModal,
    clickDate,
    setShowModalPremium,
    onBuy,
    isPremium,
}: {
    errorGuest: number;
    toggleInfoModal: (info: InfoType) => void;
    clickDate: boolean;
    setShowModalPremium: boolean;
    onBuy: (isPremiumFlag: boolean) => void;
    isPremium: boolean;
}) => {
    const [click, setClick] = useState<boolean>(false);
    const { clickConfirmDate } = useStore(state => state.checkoutState);
    const languageSelected = useStore(
        state => state.checkoutState.languageSelected
    );
    const clickLanguage = useStore(state => state.checkoutState.clickLanguage);
    const { ShoppingBag } = shoppingSvg;

    const router = useRouter();
    const { slug } = router.query;

    const { data: packageDetail } = useQuery({
        queryKey: ["packageDetailByTitle"],
        queryFn: () => getPackageDetailByTitle(slug?.[0] as string),
        refetchInterval: false,
        enabled: !!slug?.[0],
    });

    const rooms = useStore(state => state.checkoutState.orderData.rooms) || [];

    const numberRooms = rooms.length;

    const totalAmount = useStore(
        state => state.checkoutState.orderData.totalAmount
    );

    const numberPeople = rooms.reduce((acc, room) => {
        return (
            acc +
            room.adults +
            (room.children?.length ?? 0) +
            (room.newborns ?? 0)
        );
    }, 0);

    return (
        <>
            <div className={styles.container}>
                {errorGuest > 0 && click && clickDate && (
                    <div className={styles.popoverContainer}>
                        <div className={styles.popoverContainerArrow} />
                        <span className={styles.popoverContainerText}>
                            Please fix your room configuration
                        </span>
                    </div>
                )}
                {!clickDate && click && (
                    <div className={styles.popoverContainer}>
                        <div className={styles.popoverContainerArrow} />
                        <span className={styles.popoverContainerText}>
                            Please select your arrival date
                        </span>
                    </div>
                )}
                {!languageSelected &&
                    click &&
                    clickDate &&
                    errorGuest === 0 && (
                        <div className={styles.popoverContainer}>
                            <div className={styles.popoverContainerArrow} />
                            <span className={styles.popoverContainerText}>
                                Please select your tour language
                            </span>
                        </div>
                    )}
            </div>
            <div className={stylesAddToCart.buttonBuySection}>
                <MDBBtn
                    className={
                        errorGuest > 0 ||
                        !clickDate ||
                        !languageSelected ||
                        !clickLanguage ||
                        !clickConfirmDate
                            ? `${stylesAddToCart.addToCartButtonDisabled}`
                            : `${stylesAddToCart.addToCartButton}`
                    }
                    onClick={() => {
                        setClick(true);
                        if (
                            errorGuest === 0 &&
                            clickDate &&
                            languageSelected &&
                            clickConfirmDate &&
                            clickLanguage
                        ) {
                            if (setShowModalPremium) {
                                // Solo apri il modal Premium, non inviare add_to_cart
                                toggleInfoModal(InfoType.MODAL_PREMIUM);
                            } else {
                                // Se non c'è modal Premium, invia add_to_cart e procedi
                                if (!packageDetail) return;
                                const itemData = adapterTourViewItemGAnalytics(
                                    packageDetail,
                                    isPremium
                                );

                                const itemToAdd = itemData.items[0];

                                const dataLayerPayload = addToCart(
                                    itemToAdd,
                                    totalAmount,
                                    numberRooms,
                                    numberPeople
                                );

                                TagManager.dataLayer(dataLayerPayload);

                                onBuy(isPremium);
                            }
                        }
                    }}
                >
                    Reserve
                    <div className="ps-3 pt-1">
                        <ShoppingBag />
                    </div>
                </MDBBtn>
                <p style={{ color: "darkgrey", fontSize: "13px" }}>
                    You won’t be charged yet
                </p>
            </div>
        </>
    );
};

export default ButtonBuySectionDetail;
